module.exports = __webpack_public_path__ + "img/Nissan.dfa1b222.png";